var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentMaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 28,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3001 20.7313C19.8702 21.9738 18.0154 22.7238 15.9886 22.7238C11.4662 22.7238 7.80005 18.9894 7.80005 14.3827C7.80005 9.77607 11.4662 6.04163 15.9886 6.04163C18.0154 6.04163 19.8702 6.7917 21.3001 8.03421C22.7299 6.7917 24.5847 6.04163 26.6115 6.04163C31.1339 6.04163 34.8001 9.77607 34.8001 14.3827C34.8001 18.9894 31.1339 22.7238 26.6115 22.7238C24.5847 22.7238 22.7299 21.9738 21.3001 20.7313Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3 20.7313C23.0607 19.2013 24.1771 16.9248 24.1771 14.3827C24.1771 11.8406 23.0607 9.56412 21.3 8.03421C22.7299 6.7917 24.5847 6.04163 26.6115 6.04163C31.1339 6.04163 34.8001 9.77607 34.8001 14.3827C34.8001 18.9894 31.1339 22.7238 26.6115 22.7238C24.5847 22.7238 22.7299 21.9738 21.3 20.7313Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3001 8.0343C23.0607 9.56421 24.1771 11.8407 24.1771 14.3828C24.1771 16.9249 23.0607 19.2014 21.3001 20.7313C19.5395 19.2014 18.4231 16.9249 18.4231 14.3828C18.4231 11.8407 19.5395 9.56421 21.3001 8.0343Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMaster);
export default __webpack_public_path__ + "static/media/PaymentMaster.c2d5889ca52210fa3b4de9db8947e769.svg";
export { ForwardRef as ReactComponent };